//directive controller function
var HoryzontalScrollDirectiveController = function ($scope, $element, $attrs) {
    var DEFAULT_SCROLL_OFFSET = 40;
    //scrollLeft
    //
    //@param {Object} event data object. It is required to pass it as a first parameter of the method
    //@param {Number} scroll offset
    //
    //@description
    //Method scrolles content left by setted scroll length
    $scope.scrollLeft = function ($event, scrollLength) {
        if (!$event) {
            throw new Error('')
        }

        scrollLength = scrollLength || DEFAULT_SCROLL_OFFSET;
        var data = {
            element: $event.currentTarget.parentElement,
            offset: parseInt(scrollLength)
        }
        $scope.$broadcast('scroll-directive:scroll-left', data);
    };
    //scrollRight
    //
    //@param {Object} event data object. It is required to pass it as a first parameter of the method
    //@param {Number} scroll offset
    //
    //@description
    //Method scrolles content right by setted scroll lenght
    $scope.scrollRight = function ($event, scrollLength) {
        scrollLength = scrollLength || DEFAULT_SCROLL_OFFSET;
        var data = {
            element: $event.currentTarget.parentElement,
            offset: parseInt(scrollLength)
        }
        $scope.$broadcast('scroll-directive:scroll-right', data);
    };
};
//directive controller function injections
HoryzontalScrollDirectiveController.$inject = ['$scope', '$element', '$attrs'];
//main directive function
var HoryzontalScrollDirective = function () {
    return {
        restrict: 'A',
        controller: HoryzontalScrollDirectiveController
    }
};
angular.module('OSS').directive('horyzontalScroll', HoryzontalScrollDirective);
// horizont scroll directive content controller
var HoryzontalScrollContentDirectiveController = function ($scope, $element, $attrs) {
    // moves element left
    $scope.$on('scroll-directive:scroll-left', function (event, data) {
        if ($element.parent()[0] == data.element) {
            //angular.element($element)[0].scrollLeft -= data.offset;
            var offsetX = $element[0].scrollLeft - data.offset;
            $element.duScrollLeftAnimated(offsetX);
            event.preventDefault();
        }
    });
    // moves element right
    $scope.$on('scroll-directive:scroll-right', function (event, data) {
        if ($element.parent()[0] == data.element) {
            //angular.element($element)[0].scrollLeft += data.offset;
            var offsetX = $element[0].scrollLeft + data.offset;
            $element.duScrollLeftAnimated(offsetX);
            event.preventDefault();
        }
    });
};
HoryzontalScrollContentDirectiveController.$inject = ['$scope', '$element', '$attrs'];

// horizont scroll directive main function
var HoryzontalScrollContentDirective = function () {
    return {
        restrict: 'A',
        controller: HoryzontalScrollContentDirectiveController
    }
};

module.exports = HoryzontalScrollContentDirective;
